import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import Helmet from 'react-helmet';
import { AudienceBuilder } from 'containers';
import { PageHeader, Spinner } from 'components';
import * as styles from './Audiences.scss';
var AudienceBuilderWrap = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    theme: state.theme,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    audience: state.audience,
    savedAudiences: state.adsAudiences && state.adsAudiences.savedAudiences[orgId] ? state.adsAudiences.savedAudiences[orgId] : []
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceBuilderWrap, _Component);

  var _super = _createSuper(AudienceBuilderWrap);

  function AudienceBuilderWrap() {
    _classCallCheck(this, AudienceBuilderWrap);

    return _super.apply(this, arguments);
  }

  _createClass(AudienceBuilderWrap, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.audience && this.props.audience) {
        if (!prevProps.audience.id && this.props.audience.id || prevProps.audience.id !== this.props.audience.id) {//      console.log('must be an edit')
        }
      }
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var appLayoutInnerStyle = {
        display: 'flex',
        flex: '1 1 auto',
        padding: 0,
        overflow: 'auto',
        height: '100%'
      };
      var wrapStyle = {
        flex: '1 1 auto',
        padding: 0
      };
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Advertising - Audience Builder"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          borderBottom: '1px solid #f1f1f1',
          color: '#616161',
          cursor: 'pointer',
          fontSize: 20,
          lineHeight: '70px',
          paddingLeft: 16
        },
        onClick: function onClick() {
          browserHistory.push("/org/".concat(_this.props.organization.id, "/ads/audiences"));
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-android-arrow-back",
        style: {
          color: '#616161',
          cursor: 'pointer',
          fontSize: 20,
          marginRight: 16
        }
      }), "All Audiences"), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 36px'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        showCrumbs: false,
        primary: "Advertising",
        secondary: this.props.audience.isEdit ? 'Edit Audience' : 'New Audience',
        style: {
          marginBottom: 4
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '0 36px'
        }
      }, this.props.adAccount && /*#__PURE__*/React.createElement(AudienceBuilder, {
        fbTargetingConfigId: this.props.params.fbTargetingConfigId
      }))));
    }
  }]);

  return AudienceBuilderWrap;
}(Component)) || _class);
export { AudienceBuilderWrap as default };